export enum PaywallType {
  Video = 'video',
  Abo = 'abo'
}
